import {
  LIBRARY_TAXES,
  V1_TAX_BY_ID,
  V1_TAX_URL,
  TAX_ALL_OUTLET
} from './constants'

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/taxes_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */

export function getTaxes (params) {
  return axios
    .get(LIBRARY_TAXES, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/taxes_controller.rb#L26
 * @param id
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getTaxDetail (id, params) {
  return axios
    .get(V1_TAX_BY_ID(id), {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function updateTax (id, data, params) {
  return axios
    .put(V1_TAX_BY_ID(id), data, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function createTax (data, params) {
  return axios
    .post(V1_TAX_URL, data, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function deleteTax (id, params) {
  return axios
    .delete(V1_TAX_BY_ID(id), {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function createTaxAllOutlets (data, params) {
  return axios
    .post(TAX_ALL_OUTLET, data, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}



// WEBPACK FOOTER //
// ./app/api/taxes/taxes.js